var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertriebspartner-filter"},[_c('b-form-group',{attrs:{"label":"Partner","label-cols":11}},[_c('b-form-select',{attrs:{"options":_vm.partners,"plain":true},on:{"change":_vm.updateFilter},model:{value:(_vm.selectedPartner),callback:function ($$v) {_vm.selectedPartner=$$v},expression:"selectedPartner"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }